module.exports = __webpack_public_path__ + "static/media/project_maji_ar.03df85da.png";